<template>
  <div class="padding-50 fullheight pos-relative k-page">
    <Row type="flex" justify="space-between" align="middle" class="code-row-bg padding-b-20">
      <i-col flex="100px">
        <h2 style="color:#000">My listings</h2>
      </i-col>
      <i-col flex="auto" class="text-right">
        <KSelect v-model="selectedList" class="k-select" placeholder="All listings" :optionList="allList" isClearable="true" :isFilterable="true" style="width:200px;margin-right:10px;text-align:left"/>
        <Button class="k-btn-1" @click="handleSubmitListing" size="large">Submit new listing</Button>
      </i-col>
    </Row>
    <Stats :statsData="myListings"/>
    <MyListingCardList :myListings='myListings.all_listing'/>
    <Spin size="large" fix v-if="isLoading"></Spin>
  </div>
</template>

<script>
import { fetchMyListings } from '@/services/my-listings'
import Stats from '@/components/my-listing/MyListingStats'
import MyListingCardList from '@/components/my-listing/MyListingCardList'
import KSelect from '@/components/ui/Select'

export default {
  components: {
    MyListingCardList,
    Stats,
    KSelect
  },
  data () {
    return {
      selectedList: null,
      allList: [],
      myListings: {},
      isLoading: false,
      allListRaw: []
    }
  },

  watch: {
    selectedList (val) {
      if (val) {
        this.myListings.all_listing = this.allListRaw.filter(item => item.id === val)
      } else {
        this.getMyListings()
      }
    }
  },

  mounted () {
    this.getMyListings()
  },

  methods: {
    handleSubmitListing () {
      this.$router.push({
        name: 'my-listing-form'
      })
    },

    getMyListings () {
      this.isLoading = true
      fetchMyListings().then(res => {
        if (res.data.results.length > 0) {
          this.myListings = res.data.results[0]
          this.allListRaw = res.data.results[0].all_listing
          this.allList = this.parseAllListings(res.data.results[0].all_listing)
        }
        this.isLoading = false
      }).catch(err => {
        console.log('Failed to get my listings: ', err)
        this.isLoading = false
      })
    },

    parseAllListings (data) {
      if (data && data.length > 0) {
        return data.reduce((acc, cur) => {
          acc.push({
            value: cur.id,
            label: cur.name
          })
          return acc
        }, [])
      } else {
        return []
      }
    }
  }
}
</script>
